"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Collection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const collection_style_1 = __importDefault(require("./collection.style"));
class Collection extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, children, title, description, action } = this.props;
            return (jsx_runtime_1.jsxs("section", Object.assign({ className: classes.root }, { children: [title && jsx_runtime_1.jsx("div", Object.assign({ className: classes.title }, { children: title }), void 0),
                    description && (jsx_runtime_1.jsx("div", Object.assign({ className: classes.description }, { children: description }), void 0)),
                    jsx_runtime_1.jsx("ul", Object.assign({ className: classes.items }, { children: react_1.Children.map(children, child => (jsx_runtime_1.jsx("li", { children: child }, void 0))) }), void 0),
                    action && jsx_runtime_1.jsx("div", Object.assign({ className: classes.action }, { children: action }), void 0)] }), void 0));
        };
    }
}
exports.Collection = Collection;
Collection.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    children: prop_types_1.default.node.isRequired,
    title: prop_types_1.default.node,
    description: prop_types_1.default.node,
    action: prop_types_1.default.node
};
Collection.defaultProps = {
    title: null,
    description: null,
    action: null
};
exports.default = react_jss_1.default(collection_style_1.default)(Collection);
//# sourceMappingURL=collection.js.map